/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-content[_ngcontent-%COMP%]{width:500px;overflow:visible}"];
export { styles as styles };
